import { APIS } from "../../../_config";
import { CallApi } from "../callApi";

export interface SubRegionFormData {
  name: string;
  region_id: string;
}

export interface SubRegion {
  id: string;
  name: string;
  created_at: string;
  updated_at: string;
  region: {
    name: string;
    region_code: string;
    id: string;
    created_at: string;
    updated_at: string;
  };
}

export interface Region {
  id: string;
  name: string;
  region_code: string;
}

export function useSubRegionApi() {
  // List sub-regions
  const getSubRegionList = async (params: any = {}): Promise<any> => {
    const response = await CallApi.GET(APIS.LOCATION_SETTINGS.SUB_REGION.SUB_REGIONS, params, true);
    return response;
  };

  // Get single sub-region by ID
  const getSubRegionById = async (id: string): Promise<any> => {
    const response = await CallApi.GET(APIS.LOCATION_SETTINGS.SUB_REGION.DETAIL(id), {}, true);
    return response;
  };

  // Create sub-region
  const createSubRegion = async (data: SubRegionFormData): Promise<any> => {
    const response = await CallApi.POST(APIS.LOCATION_SETTINGS.SUB_REGION.CREATE, data, true);
    return response;
  };

  // Update sub-region
  const updateSubRegion = async (id: string, data: SubRegionFormData): Promise<any> => {
    const response = await CallApi.PUT(APIS.LOCATION_SETTINGS.SUB_REGION.DETAIL(id), data, true);
    return response;
  };

  // Delete sub-region
  const deleteSubRegion = async (id: string): Promise<any> => {
    const response = await CallApi.DELETE(APIS.LOCATION_SETTINGS.SUB_REGION.DETAIL(id), true);
    return response;
  };


  return {
    getSubRegionList,
    getSubRegionById,
    createSubRegion,
    updateSubRegion,
    deleteSubRegion,
  };
}
